import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { IAdminPage } from '../admin/Interfaces'
import { AdminPagesService, returnPageDetails, useReturnAdminPagesList } from '../admin/adminPagesSlice'
import AlertElement from '../../components/AlertElement'
import GridData from '../../components/GridData/GridData'
import WarehousesApp from './WarehousesApp'
import { emptyLocatiomModel, ILocationModel } from '../locations/LocationsApp'
import { error } from 'console'
import { handleRequestError } from '../../services/api'
import { updateWarehousesSearchParams } from './warehousesSlice'
import { createOrUpdateElementData } from '../../components/Form/formsSlice'

interface IWarehouseLocationBoxProps extends ILocationModel {
    isActive?: boolean,
    activeLocationId: number,
    setActiveWarehouseLocation: (locationId: number) => void,
}
export function WarehouseLocationBox(props: IWarehouseLocationBoxProps){

    const {
        id,
        title,
        isActive,
        setActiveWarehouseLocation
    } = props

    let baseSpanClassName: string = "war-loc-option-box"
    const [spanClassName, setSpanClassName] = useState<string>(baseSpanClassName)

    useEffect(() => {
        setSpanClassName(isActive ? baseSpanClassName + " active" : baseSpanClassName)
    }, [isActive])

    return <span className={spanClassName} onClick={() => setActiveWarehouseLocation(id)}>{title}</span>
}

interface IWarehousesLocationsProps {
    activeLocationId: number,
    setActiveWarehouseLocation: (locationId: number) => void,
}
export function WarehousesLocations(props: IWarehousesLocationsProps) {

    const dispatch = useDispatch()

    const {
        activeLocationId,
        setActiveWarehouseLocation,
    } = props

    const [loading, setLoading] = useState<boolean>(true)
    const [locations, setLocations] = useState<ILocationModel[]>([])

    const warehousesApp = new WarehousesApp()

    const loadLocations = () => {
        setLoading(true)

        warehousesApp.returnWarehousesLocationsList()
            .then(response => {

                let list: ILocationModel[] = response.data.locations

                // if (list.length > 0){
                //     list = [
                //         {
                //             ...emptyLocatiomModel,
                //             id: 0,
                //             title: "All"
                //         },
                //         ...list
                //     ]
                // }

                setLocations(list)
                setLoading(false)
            })
            .catch(error => {
                setLoading(false)
                handleRequestError(error, dispatch)
            })

    }

    useEffect(() => {
        loadLocations()
    }, [])

    useEffect(() => {
        if (activeLocationId === 0){
            if (!loading){
                setActiveWarehouseLocation(1)
            }
        }
    }, [activeLocationId, loading])

    if (loading || locations.length == 0){
        return <></>
    }

    return(
        <div className="warehouse-location-options-container warehouses-page">
            <div className="content-of-warehouse-location-options-container">
                {locations.map((location, index) => <WarehouseLocationBox {...location} key={index} isActive={activeLocationId == location.id ? true : false} activeLocationId={activeLocationId} setActiveWarehouseLocation={setActiveWarehouseLocation} />)}
            </div>
        </div>
    )
}

export default function WarehousesList() {

    const dispatch = useDispatch()

    const [activeLocationId, setActiveLocationId] = useState<number>(0)

    const warehousesApp = new WarehousesApp()

    const items = warehousesApp.dynamicBasePage.items()
    const selectedItems = warehousesApp.gridDataEssentials.selectedItems()
    const pagination = warehousesApp.dynamicBasePage.pagination()
    const search = warehousesApp.dynamicBasePage.search()
    const searchParams = warehousesApp.gridDataEssentials.searchParams()
    const loading = warehousesApp.dynamicBasePage.loading()

    const handleUpdateActiveLocationId = (locationId: number) => {
        setActiveLocationId(locationId)

        dispatch(createOrUpdateElementData({
            name: "location_id",
            value: locationId ? locationId : 0
        }))
    }

    // useEffect(() => {
    //     dispatch(updateWarehousesSearchParams([
    //         {
    //             name: "locations_id",
    //             value: activeLocationId ? activeLocationId : ""
    //         }
    //     ]))
    // }, [activeLocationId])

    return(
        <div className="hide-grid-data-filter-container">
            <GridData 
                items={items}
                columns={warehousesApp.gridDataColumns}
                selectedItems={selectedItems}
                pagination={pagination}
                search={search ? search : ""}
                searchParams={searchParams}
                loading={loading}
                actionButtons={warehousesApp.gridDataEssentials.actionButtons}
                headerOptions={warehousesApp.gridDataEssentials.headerOptions}
                handleLoadItems={warehousesApp.listOfInstances}
                updateSearch={(search) => {
                    if (warehousesApp.dynamicBasePage?.updateSearch){
                        warehousesApp.dynamicBasePage.updateSearch(search, dispatch)
                    }
                }}
                setSelectedItems={(items) => {
                    if (warehousesApp.gridDataEssentials?.setSelectedItems){
                        warehousesApp.gridDataEssentials?.setSelectedItems(items, dispatch)
                    }
                }}
                onDeleteItem={(id) => warehousesApp.deleteInstance(id)}
                onDeleteManyItems={(records) => warehousesApp.deleteManyInstances(records)}
                deleteItem={(id, dispatch) => warehousesApp.dynamicBasePage?.deleteItem(id, dispatch)}
                updateLoading={(status) => warehousesApp.dynamicBasePage?.updateLoadingStatus(status, dispatch)}
                updateItemSearchParams={(params) => warehousesApp.gridDataEssentials?.updateItemSearchParams(params, dispatch)}
                addNewItem={(item, dispatch) => warehousesApp.dynamicBasePage?.addNewItem(item, dispatch)}
                updateItem={(item, dispatch) => warehousesApp.dynamicBasePage?.updateItem(item, dispatch)}
                updateAllItems={(items, dispatch) => warehousesApp.dynamicBasePage?.updateAllItems(items, dispatch)}
                updateItemsPagination={(pagination, dispatch) => warehousesApp.dynamicBasePage?.updateItemsPagination(pagination, dispatch)}
                // updateSearchParamsBeforeLoadItems={(params) => {
                //     if (appClass.gridDataEssentials?.updateSearchParamsBeforeLoadItems){
                //         appClass.gridDataEssentials?.updateSearchParamsBeforeLoadItems(params, dispatch)
                //     }
                // }}

                config={{
                    ...warehousesApp.gridConfig,
                    // filterForm: undefined
                }}
                nothingFoundMessage={warehousesApp.messages.nothingFound}
                renderAdditionalSection={() => <WarehousesLocations activeLocationId={activeLocationId} setActiveWarehouseLocation={handleUpdateActiveLocationId} />}
            />
        </div>
    )
}